// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__aCVwJ","colCheckbox":"styles_colCheckbox__1iwJ4"};